import {
  DASHBOARD_APP_NAME,
  DASHBOARD_CLIENT_KEY,
  FEATURE_LABORATORY_DEVELOPMENT_URL,
  FEATURE_LABORATORY_PRODUCTION_URL,
} from '@/utils/constants/featureLaboratory'
import { type IConfig, UnleashClient } from 'unleash-proxy-client'

const isProduction = process.env.NODE_ENV === 'production'

const unleashClientKey: IConfig = {
  appName: DASHBOARD_APP_NAME,
  clientKey: DASHBOARD_CLIENT_KEY,
  environment: isProduction ? 'production' : 'development',
  url: isProduction ? FEATURE_LABORATORY_PRODUCTION_URL : FEATURE_LABORATORY_DEVELOPMENT_URL,
}

export const unleashClient = new UnleashClient(unleashClientKey)
